/**
 * Detecção de problemas de qualidade de dado no cadastro de férias.
 *
 * Usado tanto pelo painel do DP quanto pelo cadastro do colaborador para distinguir
 * problemas estruturais (histórico faltando, histórico maior que o direito) de
 * situações normais.
 */

export const NO_HISTORY_MIN_MONTHS = 24;

/**
 * Colaborador elegível há 2+ anos sem nenhuma férias lançada no histórico.
 *
 * Sinal de qualidade de dado: o saldo provavelmente está superestimado, porque nenhuma
 * férias passada foi registrada no cadastro. Comum em transições de sistema ou em
 * colaboradores que legalmente nunca usufruíram (afastamentos, contratos recentes).
 */
export function hasNoHistoryLogged({
    monthsWorked,
    legacyTakenDays,
    legacyScheduledDays,
    eligible,
}: {
    monthsWorked: number;
    legacyTakenDays: number;
    legacyScheduledDays: number;
    eligible: boolean;
}): boolean {
    if (!eligible) return false;
    if (monthsWorked < NO_HISTORY_MIN_MONTHS) return false;
    return legacyTakenDays === 0 && legacyScheduledDays === 0;
}

/**
 * Histórico lançado é maior que o direito adquirido.
 *
 * Sinal de erro de digitação ou migração: o colaborador tem mais dias no histórico
 * do que desenvolveu direito. O motor coloca o excedente em `unallocatedDays`; este
 * detector nomeia a condição para UI.
 */
export function hasHistoryOverEntitlement({
    unallocatedDays,
}: {
    unallocatedDays: number;
}): boolean {
    return unallocatedDays > 0;
}
